
<button mat-fab color="accent" aria-label="Scroll Top"
*ngIf="showBtn$ | async" class="top-btn" (click)="gotoTop()"
matTooltip="Scroll Top" >

<mat-icon>arrow_upward</mat-icon>

</button>
